import {ActionButton} from "../../../designSystem/components/ActionButton";
import React from "react";
import {Typography} from "../../../designSystem/components/Typography";

interface HeaderBarProps {
  title: string;
  actionButtonLabel: string;
  actionButtonOnClick: () => void;
  actionButtonIcon?: string;
}

export const HeaderBar = ({
  title,
  actionButtonLabel = '',
  actionButtonOnClick = () => null,
  actionButtonIcon = 'fa-plus',
}: HeaderBarProps) => (
  <div className="flex-1 flex items-center justify-between p-4 border-b h-[73px]">
    <Typography variant="title" className="pl-2">
      {title}
    </Typography>
    {actionButtonLabel
      ?
      <ActionButton
        label={actionButtonLabel}
        iconName={actionButtonIcon}
        onClick={actionButtonOnClick}
      />
      : null
    }
  </div>
)
